import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { InvestorLiabilitiesModel } from 'models';
import { formatNum } from 'utils';

import { Loader, Centered, Error } from 'components';

import { useStyles } from './style';

interface Props {
  investorLiabilities: InvestorLiabilitiesModel;
  loading: boolean;
  error: boolean;
}

const LiabilitiesAddonDetails: React.FC<Props> = ({
  investorLiabilities,
  loading,
  error,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const renderBody = () => {
    return (
      <div>
        <h4 className={classes.addonTitle}>
          {t('#portal.investor.dashboard.liabilitiessaldo')}
        </h4>
        <div>
          <div className={classes.cell}>
            <h5 className={classes.title}>
              {t('#portal.investor.dashboard.liabilitiessaldo.total')}
            </h5>
            <p className={classes.amount}>
              {formatNum(investorLiabilities.TotalAmount)} €
            </p>
          </div>
          <div className={classes.cell}>
            <h5 className={classes.title}>
              {t('#portal.investor.dashboard.liabilitiessaldo.balance')}
            </h5>
            <p className={classes.amount}>
              {formatNum(investorLiabilities.BalanceAmount)} €
            </p>
          </div>
          <div className={classes.cell}>
            <h5 className={classes.title}>
              {t('#portal.investor.dashboard.liabilitiessaldo.inhand')}
            </h5>
            <p className={classes.amount}>
              {formatNum(investorLiabilities.InHand)} €
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {error ? (
        <Centered>
          <Error />
        </Centered>
      ) : null}
      {loading ? (
        <Centered>
          <Loader size={30} themeColor="darkBlue" />
        </Centered>
      ) : null}
      {loading || error ? null : renderBody()}
    </>
  );
};

export default memo(LiabilitiesAddonDetails);
